import axios from 'axios';
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const API_PATH = `${process.env.REACT_APP_ENV === 'local' ? '' : '/tsp'}`;
const API_PATH_V2 = `${process.env.REACT_APP_ENV === 'local' ? '' : '/v2'}/manage/dashboard`;

export const loginHandle = createAsyncThunk('login', async body => {
	const response = await axios.post('/LuxgenVIG/VIGP1/driverManagement/driverLogin', JSON.stringify(body));
	
	return response;
})

export const tspLoginHandle = createAsyncThunk('loginTSP', async body => {
	const response = await axios.post(`${API_PATH}/manage/dashboard/managerLogin`, JSON.stringify(body));
	return response;
	// const response = await axios.post(`${API_PATH_V2}/managerLogin`, JSON.stringify(body));
	// return response.data;
})

export const resetHandle = createAsyncThunk('reset', async body => {
	const response = await axios.put(`${API_PATH}/manage/common/reset`, JSON.stringify(body));
	
	return response;
})

export const loginSlice = createSlice({
    name: 'login',
    initialState: {
        authorization: null,
        name: null
    },
    reducers: {
		resetState: (state, props) => {
			state.authorization = null;
			state.name = null;
			localStorage.removeItem('persist:root');
			localStorage.removeItem('authorization');
		}
	},
    extraReducers: builder => {
        builder.addCase(loginHandle.fulfilled, (state, {payload: {token, name}}) => {
			state.authorization = token;
			state.name = name;
			localStorage.setItem('authorization', token);
		})
		builder.addCase(tspLoginHandle.fulfilled, (state, {payload: {token, account}}) => {
			state.authorization = token;
			state.name = account;
			localStorage.setItem('authorization', token);
		})
		builder.addCase(resetHandle.fulfilled, (state, { payload, payload: { account, token } }) => {
			state.authorization = token;
			state.account = account;			
			localStorage.setItem('authorization', token);
		})
    }
})

export const { resetState } = loginSlice.actions;
export default loginSlice.reducer;
